import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_FORMOU_HTTP_API,
});

export default api;
